export const ACTIVITY_STATUSES_OF_APPROVAL = [
  { id: 1, name: 'entities.activities.statuses_of_approval.1', assignable: true },
  { id: 2, name: 'entities.activities.statuses_of_approval.2', assignable: false },
  /* { id: 3, name: 'entities.activities.statuses_of_approval.3', assignable: false }, */
  { id: 4, name: 'entities.activities.statuses_of_approval.4', assignable: true }
]

export const ACTIVITY_STATUSES = [
  { id: 1, name: 'entities.activities.statuses.1' },
  { id: 2, name: 'entities.activities.statuses.2' },
]
